export class CampaignError extends Error {
  constructor(
    message: string,
    public code: string,
    public meta?: any,
  ) {
    super(message);
    this.name = 'CampaignError';
  }
}

export class NetworkError extends CampaignError {
  constructor(
    message: string,
    public status?: number,
    meta?: any,
  ) {
    super(message, 'NETWORK_ERROR', meta);
    this.name = 'NetworkError';
  }
}

export class ValidationError extends CampaignError {
  constructor(
    message: string,
    public field?: string,
    meta?: any,
  ) {
    super(message, 'VALIDATION_ERROR', meta);
    this.name = 'ValidationError';
  }
}

export class ConfigurationError extends CampaignError {
  constructor(message: string, meta?: any) {
    super(message, 'CONFIGURATION_ERROR', meta);
    this.name = 'ConfigurationError';
  }
}

export class SelectorError extends CampaignError {
  constructor(
    message: string,
    public selector?: string,
    meta?: any,
  ) {
    super(message, 'SELECTOR_ERROR', meta);
    this.name = 'SelectorError';
  }
}

export class ModificationError extends CampaignError {
  constructor(
    message: string,
    public action?: string,
    meta?: any,
  ) {
    super(message, 'MODIFICATION_ERROR', meta);
    this.name = 'ModificationError';
  }
}
